module.exports = __webpack_public_path__ + "static/media/tutorial-map.5a9fe066.jpg";